export const formatters = {
  productsCount: (count: number) =>
    `${count} ${count === 1 ? 'produto' : 'produtos'}`,
}
